// extracted by mini-css-extract-plugin
export default {"wrapper":"Snapping__wrapper___2YN93","label":"Snapping__label___2e8Y9"};